import { log } from '../logger';
import { LocaleType } from '@/i18n';

type PageType = {
  locale: LocaleType;
  pathname: string;
};

export interface RedirectOnSlugDifferenceProps {
  slugFromParams: string;
  slugFromData: string;
  page: PageType;
}

const isValidSlug = (slug: string) => {
  if (!slug) {
    return false;
  }

  // Check if the slug contains valid shape with _ delimiter before ID. Slug example: manual-profile-download_727206
  const slugRegex = /^[a-zA-Z0-9-_]+_[0-9]+$/;
  const isSlugShape = slugRegex.test(slug);
  if (!isSlugShape) {
    return false;
  }

  // Check if the slug contains only allowed characters. Japanese included.
  const allowedCharactersRegex = /^[a-zA-Z0-9-_ぁ-んァ-ン一-龥ー]+$/;
  const isAllowedCharacters = allowedCharactersRegex.test(slug);
  if (!isAllowedCharacters) {
    return false;
  }
  return true;
};

export const checkSlugValidity = (slugs: string[], meta: RedirectOnSlugDifferenceProps) => {
  const slugValidity = slugs.map(slug => {
    if (!isValidSlug(slug)) {
      // log.warning(
      //   `Slug is not valid: ${slug}. Slug from data: ${meta?.slugFromData}, Slug from params: ${meta?.slugFromParams}, Page: ${meta.page.pathname}, Locale: ${meta.page.locale};`
      // );
      // Note added by Ithan: Do we really need a warn log here? Its too noisy.
      log.debug(
        `[redirectOnSlugDifference_checkSlugValidity] Slug is not valid: ${slug}. Slug from data: ${meta?.slugFromData}, Slug from params: ${meta?.slugFromParams}, Page: ${meta.page.pathname}, Locale: ${meta.page.locale};`
      );
      return false;
    }
    return true;
  });

  return slugValidity.every(isValid => isValid);
};
